import { Tag } from "@pallet/components/content/Tag"
import { Box, Text } from "@pallet-hq/hegel"
import { formatSnakeCaseToReadableString } from "utils/stringFormatter"
import { OfficePreferenceEnum } from "__generated__/globalTypes"
import { MiniCompanyProfile_company } from "__generated__/MiniCompanyProfile_company"

const InfoTag = (props: { label: string; value: string | number }) => {
    return (
        <Tag size="medium" p="4px 8px">
            <Box display="flex" gridGap="xsmall">
                <Text variant="uiTiny500" style={{ fontWeight: 600 }}>
                    {props.label}
                </Text>
                <Text variant="uiTiny400">{props.value}</Text>
            </Box>
        </Tag>
    )
}

const InformationSection = ({
    company,
}: {
    company: MiniCompanyProfile_company
}) => {
    const formattedCities = company.cities.edges
        .map(city => city.node.shortLabel)
        .join(", ")
    let office = company.officePreference
        ? company.officePreference != OfficePreferenceEnum.ONSITE_OR_REMOTE
            ? formatSnakeCaseToReadableString(company.officePreference)
            : "Hybrid"
        : ""
    office = company.cities.edges.length
        ? office + ", " + formattedCities
        : office

    return (
        <Box width="100%">
            <Box display="flex" flexWrap="wrap" gridGap="xxsmall" width="100%">
                {!!office.length && <InfoTag label="Works" value={office} />}
                {!!company.yearFounded && (
                    <InfoTag label="Founded" value={company.yearFounded} />
                )}
                {company.size && (
                    <InfoTag
                        label="Size"
                        value={`${company.size.name} employees`}
                    />
                )}
                {company.fundingLevel && (
                    <InfoTag
                        label="Stage"
                        value={company.fundingLevel.intuitiveName}
                    />
                )}
                {company.totalRaised && (
                    <InfoTag
                        label="Raised"
                        value={`$${parseFloat(company.totalRaised).toFixed(
                            1
                        )} M`}
                    />
                )}
            </Box>
        </Box>
    )
}

export { InformationSection }
